import { Component, OnInit, Output, EventEmitter, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Utility } from '../../utility/utility';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { jaLocale, enGbLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';

@Component({
    selector: 'app-date-picker',
    templateUrl: './datePicker.component.html',
    styleUrls: ['./datePicker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerComponent),
            multi: true,
        },
    ],
})
export class DatePickerComponent implements OnInit, OnChanges {
    format = {
        en: 'DD/MM/YYYY',
        ja: 'YYYY年M月'
    };
    @Output() oValueChange = new EventEmitter();
    @Input() dpConfig = new BsDatepickerConfig();
    @Input() datesetting: Date;
    @Input() isReadOnly: any;
    @Input() showClearButton = false;
    @Input() minModeDay = false;
    @Input() prefDate: Date = null;
    @Input() typeLanguage = '';
    public inputWidth: number;
    constructor(private util: Utility, private localeService: BsLocaleService) {
    }
    setLocate(lang: string) {
        const locate = lang;
        switch (locate) {
            case 'en':
                defineLocale('en', enGbLocale);
                this.dpConfig.dateInputFormat = this.format.en;
                break;
            default:
                defineLocale('ja', jaLocale);
                this.dpConfig.dateInputFormat = this.format.ja;
                break;
        }
        this.localeService.use(lang);
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.util.isNullOrEmpty(changes.datesetting)) {
            this.datesetting = changes.datesetting.currentValue;
            this.changeDate(this.datesetting);
        }
        if (!this.util.isNullOrEmpty(changes.typeLanguage) && changes.typeLanguage.currentValue !== ''
            && changes.typeLanguage.currentValue !== changes.typeLanguage.previousValue) {
            this.setLocate(changes.typeLanguage.currentValue);
        }
    }
    ngOnInit() {
        this.setLocate('ja');
        this.dpConfig.containerClass = 'theme-white';
        this.dpConfig.adaptivePosition = true;
        if (this.util.isNullOrEmpty(this.dpConfig.minDate)) {
            this.dpConfig.minDate = new Date(2012, 12, 1);
        }
        if (this.util.isNullOrEmpty(this.dpConfig.maxDate)) {
            const date = new Date();
            this.dpConfig.maxDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        }
    }

    changeDate(pVal: Date) {
        this.oValueChange.emit(pVal);
    }
    onOpenCalendar(container) {
        if (!this.minModeDay) {
            let month = null;
            if (container._config.value) {
                month = container._config.value.getMonth();
            }
            container.monthSelectHandler = (event: any): void => {
                container._store.dispatch(container._actions.select(event.date));
            };
            this.activeCurrentMonth(month);
        } else {
            $('.bs-datepicker bs-calendar-container[ng-reflect-ng-switch="day"]').css('width', '230px');
            $('.bs-datepicker-head bs-datepicker-navigation-view').each(function () {
                this.childNodes.forEach(item => {
                    if (item.nodeType === this.TEXT_NODE) {
                        item.remove();
                    }
                });
            });
        }
        // Set position datepicker (bottom-left of input):
        const datePickerW = $('.bs-datepicker').width();
        $('.bs-datepicker').css('transform', 'translate(' + (datePickerW - this.inputWidth) / 2 + 'px ,0)');
    }
    activeCurrentMonth(cMonth) {
        setTimeout(() => {
            if (cMonth) {
                cMonth = (cMonth + 1).toString();
                $(document).find('.bs-media-container.ng-star-inserted .bs-datepicker-body table tr td span').each(function () {
                    if (cMonth.length === 1) {
                        if (cMonth === $(this).text().substr(0, 1)) {
                            $(this).addClass('selected');
                        }
                    } else {
                        if (cMonth === $(this).text().substr(0, 2)) {
                            $(this).addClass('selected');
                        }
                    }

                });
            }
        }, 50);
    }

    clearValue() {
        this.datesetting = null;
        this.oValueChange.emit(this.datesetting);
    }

    onClickInput(event) {
        this.inputWidth = event.target.offsetWidth;
        if (this.minModeDay) {
            this.dpConfig.containerClass = 'theme-white choose-date';
            this.dpConfig.minMode = 'day';
            // this.dpConfig.dateInputFormat = 'YYYY年MM月DD日';
            this.dpConfig.selectFromOtherMonth = true;
            this.dpConfig.showWeekNumbers = false;
        } else {
            this.dpConfig.containerClass = 'theme-white';
            this.dpConfig.minMode = 'month';
            // this.dpConfig.dateInputFormat = 'YYYY年M月';
        }
    }
}
